<template lang="html">
  <div class="draft-selected">
    <div class="overview" v-if="!mostRecentlyDraftedPlayer">
      <h1>{{ draft.name }}</h1>
      <h2>Welcome to your 2018 Fantasy Football Draft</h2>
    </div>

    <template v-else>
      <draft-selected-player
        last-pick
        :player="mostRecentlyDraftedPlayer"
        :reveal="reveal"
      />

      <div class="team">
        {{ lastTeamToPick.name }}
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import DraftSelectedPlayer from './DraftSelectedPlayer';

export default {
  components: {
    DraftSelectedPlayer,
  },

  data() {
    return {
      reveal: true,
      pickInTimeout: null,
    };
  },

  computed: {
    ...mapState({
      draft: ({ draft }) => draft.draft,
      lastDrafted: ({ draft }) => draft.draft.lastDrafted,
    }),

    ...mapGetters({
      lastTeamToPick: 'draft/lastTeamToPick',
      mostRecentlyDraftedPlayer: 'draft/mostRecentlyDraftedPlayer',
    }),
  },

  watch: {
    lastDrafted(pick, lastPick) {
      if (pick && pick !== lastPick) {
        clearTimeout(this.pickInTimeout);

        this.reveal = false;

        this.pickInTimeout = setTimeout(() => {
          this.reveal = true;
        }, 2000);
      }
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-selected {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: $dark-color-active;
    color: $white-color;
    border-bottom: 2px solid $black-color;
  }

  .overview {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: $gp * 2;
  }

  .team {
    padding: $gp;
    background-color: $black-color;
    color: $white-color;
    text-align: center;
  }
</style>
